<template>
    <section class="order-basket-details">
        <div class="order-basket-details-bloc">
            <header class="order-basket-details-list">
                <div>
                    <div class="basket-title">
                        <span class="arrow pointer" @click="toggleBasket();">
                            <span v-show="!isOpen"><i class="fas fa-angle-down"></i></span>
                            <span v-show="isOpen"><i class="fas fa-angle-up"></i></span>
                        </span>
                        <h3 class="basketName">
                            {{ basket.name }} <span class="countItems">({{ basket.nbItems }} {{ $t("orders.tableOrder.items") }})</span>
                        </h3>
                    </div>
                    <div class="basket-subTotal txtRight">
                        <span class="subTotal">{{ $t("orders.tableOrder.labelSubTotal") }}:</span>
                        <span class="subTotal-price">
                            {{ displayRealPrice(basket.finalPrice, order.priceShown) | CurrencyCustomPipe("en-US", basket.currency.shortName) }}</span
                        >
                    </div>
                </div>
            </header>

            <div class="basketContent" v-if="isOpen">
                <div v-for="item in basket.orderItems" :key="item.id">
                    <OrderBasketItem :item="item" :currency="basket.currency"></OrderBasketItem>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import OrderBasketItem from "./OrderBasketItem";

export default {
    name: "orderBasketDetails",
    props: ["basket"],
    components: { OrderBasketItem },
    data() {
        return {
            isOpen: true
        };
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder"
        })
    },
    methods: {
        toggleBasket() {
            this.isOpen = !this.isOpen;
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

.order-basket-details {
    &-bloc {
        border: 1px #bebebe solid;
        margin: 20px 0px;
        overflow-x: hidden;
    }

    &-list {
        padding: 5px;
        background-color: #f4f4f4;
        text-transform: uppercase;
        &:after {
            content: "";
            display: block;
            clear: both;
        }
        & .basket-title {
            float: left;
            width: 50%;
        }
        & .basket-subTotal {
            float: left;
            width: 50%;
        }
        .arrow {
            color: $color4;
        }
        .basketName {
            font-size: 14px;
        }
        .basketName {
            display: inline-block;
            margin: 5px 0;
            width: auto;
            font-weight: normal;
        }
        .subTotal {
            display: inline-block;
            margin: 5px 25px;
            width: auto;
            text-transform: uppercase;
            font-weight: normal;
        }
    }
}
</style>



// WEBPACK FOOTER //
// orderBasketDetails.vue?dba2ece0